/**
 * Shared capability for plugin-store administration by explicitly authorized administrators.
 * Requires the admin role AND capability; local use and general settings grant no store rights.
 */
export const PLUGIN_STORE_MANAGE_PERMISSION = 'plugins:manage';
export const PLUGIN_STORE_ADMIN_ROLE = 'admin';
export function canManagePluginStore(
  permissions: readonly string[],
  role: string | undefined,
): boolean {
  return role === PLUGIN_STORE_ADMIN_ROLE && permissions.includes(PLUGIN_STORE_MANAGE_PERMISSION);
}
